"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypography = exports.MONOSPACE_FONT_FAMILY = void 0;
exports.MONOSPACE_FONT_FAMILY = "'Lab Grotesque Mono', 'Courier New', monospace";
// Comments above type definitions are the respective names in Yama
const getTypography = (text) => {
    // Title
    const h1 = {
        color: text.primary,
        fontSize: '1.71rem',
        fontStyle: 'normal',
        fontWeight: 300,
        marginBottom: '0.5rem',
        textTransform: 'none',
    };
    // Title Small
    const h2 = {
        color: text.primary,
        fontSize: '1.43rem',
        fontStyle: 'normal',
        fontWeight: 300,
        marginBottom: '0.5rem',
        textTransform: 'none',
    };
    // Subtitle
    const h3 = {
        color: text.secondary,
        fontSize: '1.15rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
        textTransform: 'none',
    };
    // Subtitle Light
    const h4 = {
        color: text.primary,
        fontSize: '1.15rem',
        fontStyle: 'normal',
        fontWeight: 300,
        marginBottom: '0.5rem',
        textTransform: 'none',
    };
    // N/A
    const h5 = {
        color: text.primary,
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
        textTransform: 'none',
    };
    // N/A
    const h6 = {
        color: text.primary,
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 500,
        marginBottom: '0.5rem',
        textTransform: 'none',
    };
    // Text Heavy
    const subtitle1 = {
        color: text.secondary,
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 500,
        textTransform: 'none',
    };
    // Text Small Heavy
    const subtitle2 = {
        color: text.secondary,
        fontSize: '0.86rem',
        fontStyle: 'normal',
        fontWeight: 500,
        textTransform: 'none',
    };
    // Text
    const body1 = {
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
        textTransform: 'none',
    };
    // Text Small
    const body2 = {
        fontSize: '0.86rem',
        fontStyle: 'normal',
        fontWeight: 400,
        textTransform: 'none',
    };
    // Button
    const button = {
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
        textTransform: 'none',
    };
    // Label
    const caption = {
        color: text.primary,
        fontSize: '0.86rem',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        fontWeight: 700,
    };
    // Code
    const code = {
        fontFamily: exports.MONOSPACE_FONT_FAMILY,
        color: text.primary,
        fontSize: '0.86rem',
        fontStyle: 'normal',
        fontWeight: 400,
        textTransform: 'none',
    };
    return {
        body1,
        body2,
        button,
        caption,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        subtitle1,
        subtitle2,
        code,
    };
};
exports.getTypography = getTypography;
